import { Store } from 'store/index';
import { AppBundle } from 'api/optimalprint-sdk.d';
import { ProductType } from '../types';
import getPredesignedBundleGroups from './getPredesignedBundleGroups';
import getPersonalisedBundleGroups from './getPersonalisedBundleGroups';
import getProductType from './getProductType';

const getBundleGroups = (store: Store) => {
  const productType = getProductType(store);
  switch (productType) {
    case ProductType.predesigned:
      return getPredesignedBundleGroups(store);
    case ProductType.personalized:
      return getPersonalisedBundleGroups(
        store,
      ) as AppBundle.Api.Entity.Design.V1.DesignAbstractProduct.DesignProductItem.IBundleGroup[];
    default:
      return [];
  }
};

export default getBundleGroups;
